import moment from 'moment';

const OverviewLeft = (props) => {
    const { data, setActiveTab, translations } = props;

    const dangerousTags = [
        'script',
        'style',
        'iframe',
        'embed',
        'object',
        'img',
        'video',
        'audio',
        'source',
        'link'
    ];

    const sanitizeHtml = (html) => {
        if (!html) return '';
        let result = html;
        dangerousTags.forEach(tag => {
            result = result.replace(new RegExp(`<${tag}[\\s\\S]*?>[\\s\\S]*?<\\/${tag}>`, 'gi'), '');
            result = result.replace(new RegExp(`<${tag}[^>]*?\\/?>`, 'gi'), '');
        });
        return result;
    };

    const formatHtml = (text) => {
        let sanitized = sanitizeHtml(text);
        // Convert URLs to clickable anchor tags
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const formattedText = sanitized?.replace(urlRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline">${url}</a>`)?.replace(/\n/g, "<br/>"); // Preserve line breaks

        console.log("formattedText", formattedText);

        return formattedText;
    };

    return (
        <>
            <div className='flex flex-col gap-2 pb-5 mb-8'>
                <label className='text-lg font-bold mb-3'>{translations?.campaignDescription}</label>
                <p className="text-sm" dangerouslySetInnerHTML={{ __html: formatHtml(data?.campaign_requirements) }}></p>
            </div>
            <div className="border-b border-lightGray mt-12">
                <p className="text-gray text-xs mb-4">{translations?.createdAt} {moment(data?.created_at).format('MMM YYYY')}</p>
            </div>
        </>
    )
}

export default OverviewLeft
